import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ExtendedSearchService } from '@fi-app/utilities/fi-services/extended-search.service';
import { AppTextService } from '@fi-shared/app-text';
import { FiFileUpload2Service } from '@fi-shared/fi-insert-media/fi-file-upload2.service';
import { FiMediaBankFileModel } from '@fi-shared/models';
import { MobileAppHelperBaseService } from '@fi-shared/fi-shared-services/mobile-app-helper-base.service';
import { FiDialogsService } from '@fi-shared/fi-dialogs';

export interface INewsFeedEditMobileSelectFileDialogData {
    limit: number; // maximum number of files to be selected
    selectedCount: number; // already selected number of files
}

@Component({
    selector: 'fi-news-feed-edit-mobile-select-file-dialog',
    templateUrl: './select-file-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./select-file-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NewsFeedEditMobileSelectFileDialog {
    constructor(
        private matDialogRef: MatDialogRef<NewsFeedEditMobileSelectFileDialog, Promise<FiMediaBankFileModel[]>>,
        private extendedSearchService: ExtendedSearchService,
        private fileUploadService: FiFileUpload2Service,
        @Inject(MAT_DIALOG_DATA) public data: INewsFeedEditMobileSelectFileDialogData,
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
        private mobileAppHelper: MobileAppHelperBaseService,
    ) {}

    inputFileChange($event) {
        if ($event.target.files && $event.target.files.length > 0) this.onFilesSelected($event.target.files);
    }

    onFilesSelected(files: FileList) {
        if (this.checkLimit(files.length))
            this.matDialogRef.close(
                this.fileUploadService.uploadFiles({
                    files: files,
                }),
            );
    }

    browseMediaBank() {
        const params: any = { multiple: true };
        this.extendedSearchService.openExtendedSearch(ObjectTypes.MediaBank, params).then((MediaBankFile) => {
            const result = Array.isArray(MediaBankFile) ? MediaBankFile : [MediaBankFile];
            if (this.checkLimit(result.length)) this.matDialogRef.close(Promise.resolve(result));
        });
    }

    checkLimit(addCount): boolean {
        if (addCount > this.data.limit - this.data.selectedCount) {
            this.fiDialogsService.notify({
                messageText: String.format(this.appTextService.get('media_bank.upload_limit_error'), this.data.limit),
            });
            return false;
        }

        return true;
    }

    isMobileAppMode() {
        return this.mobileAppHelper.mobileAppMode;
    }
}
